import React from "react";
import ProcessStatusOverview from "./ProcessStatusOverview";
import useQuickSummary from "./useQuickSummary";
import TrendVisualization from "./TrendVisualization";
import { Dropdown } from "primereact/dropdown";
import FilterDropdown from "~/components/FilterDropdown";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Chip } from "primereact/chip";
import EmptyDataView from "~/components/nodataview";
import filter from "~/assets/images/filter.png";
import { Skeleton } from "primereact/skeleton";
const QuickSummary = ({ allEntities, isloading }) => {
  const {
    statusOptions,
    mergedStatusCounts,
    data,
    loading,
    kpiCardData,
    isFetchingKpiData,
    duration,
    handleSetDuration,
    selectedFilters,
    setSelectedValues,
    setSelectedFilters,
    applyFilters,
    deSelectAll,
    chipData,
    entitiesSubOptions,
    serviceSubOptions,
    countryServiceSubOptions,
    handleRemoveFilter,
    getService,
    getEntity,
    showFilter,
    isdKpiAllZero,
    isFiltering,
    isDataAvailable,
  } = useQuickSummary({ allEntities });

  const durationOptions = [
    { name: "Last 7 Days", code: 7 },
    { name: "Last 30 Days", code: 30 },
    { name: "Last 180 Days", code: 180 },
    { name: "Last 365 Days", code: 365 },
  ];
  const filterOptions = [
    ...(serviceSubOptions.length > 1
      ? [
          {
            name: "Service Line",
            id: "service_line",
            suboptions: serviceSubOptions || [],
          },
        ]
      : []),
    ...(countryServiceSubOptions?.length > 1
      ? [
          {
            name: "Country",
            id: "country",
            suboptions: countryServiceSubOptions.map((countryCode) => {
              return {
                name: getName(countryCode),
                code: countryCode,
                icon: () => (
                  <ReactCountryFlag
                    className="country__flag"
                    countryCode={countryCode}
                    svg
                  />
                ),
              };
            }),
          },
        ]
      : []),
    ...(entitiesSubOptions?.length > 1
      ? [
          {
            name: "Entities",
            id: "entities",
            suboptions: entitiesSubOptions || [],
          },
        ]
      : []),
  ];
  const getLabel = (data) => {
    if (data?.category === "country") {
      return (
        <span>
          <ReactCountryFlag
            countryCode={data?.value}
            svg
            className="country__flag"
          />
          {getName(data?.value)}
        </span>
      );
    } else if (data?.category === "service_line") {
      return getService(data?.value)?.name;
    } else {
      return getEntity(data?.value)?.name;
    }
  };
  return (
    <div className="card__container quick_summary border-gray mt-4 p-4">
      <p className="heading mb-3">
        Quick Summary{" "}
        {(loading || isFetchingKpiData) && (
          <span className="pi pi-spin pi-spinner loading-spinner" />
        )}
      </p>
      <div className="flex justify-content-between mb-3">
        <Dropdown
          value={duration}
          onChange={handleSetDuration}
          options={durationOptions}
          optionLabel="name"
          optionValue="code"
          placeholder="Select Duration"
        />
        {!isloading ? (
          showFilter ? (
            <FilterDropdown
              groupedOptions={filterOptions}
              filterCount={chipData?.length}
              value={selectedFilters}
              onChange={(e) => {
                setSelectedValues(e.grouped);
                setSelectedFilters(e.value);
              }}
              applyFilter={applyFilters}
              deSelectAll={deSelectAll}
              placeholder="All events"
              loading={isFiltering}
            />
          ) : null
        ) : (
          <Skeleton width="130px" height="47px" />
        )}
      </div>
      <p className="helper-text">
        This period applies only to the KPIs below and uses Process Start Date
        for calculation.
      </p>
      <div className="filter-chips-container mb-3">
        {chipData?.length ? `Filters (${chipData?.length})` : null}
        {chipData?.map((data) => (
          <Chip
            key={`${data?.category}-${data?.value}`}
            label={
              <span
                key={`${data?.category}-${data?.value}`}
                className="filter__chip"
              >
                {getLabel(data)}
                <span className="cross__icon">
                  <i
                    className="pi pi-times"
                    onClick={() => handleRemoveFilter(data)}
                  />
                </span>
              </span>
            }
            removable={false}
          />
        ))}
      </div>
      {!isDataAvailable ? (
        <div className="flex">
          <ProcessStatusOverview
            data={data}
            statusOption={statusOptions}
            statusCounts={mergedStatusCounts}
            loading={loading}
          />
          <div className="flex-1 trend_visualization">
            <TrendVisualization
              loading={isFetchingKpiData}
              cardDate={kpiCardData}
              duration={duration}
            />
          </div>
        </div>
      ) : (
        <EmptyDataView
          Icon={
            <img
              className="users-card-icon-img"
              src={filter}
              alt="Users Icon"
            />
          }
          Header={"No results found"}
          Description={"Try adjusting your filters to see more data."}
        />
      )}
    </div>
  );
};

export default QuickSummary;
